<template>
  <draggable :value="value" :move="dragMove" @input="$emit('input', $event)" @end="dragEnd">
    <slot :draggingId="draggingId" :list="value"></slot>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    value: { type: Array, default: () => [] }
  },
  data: () => ({
    draggingId: null
  }),
  methods: {
    dragEnd() {
      this.draggingId = null
    },
    dragMove(draggedContext) {
      this.draggingId = draggedContext.draggedContext.element.id
      return true
    }
  }
}
</script>
